import { createApp } from 'vue';
import Toasts from '../modules/sat/components/toasts/Toasts';
import { satGlobals } from '../sat/helper/sat-globals';
import { getPiniaInstance } from '../../lib-sat/store/page-store';
import { globalLogger } from './global-logger';

function initToasts() {
    if (global.TOASTS_INITIALIZED) {
        globalLogger.log('double import toasts');

        return;
    }

    global.TOASTS_INITIALIZED = true;

    if (satGlobals.getEnv() !== 'prod') {
        import('../../qaamgo/helper/unpublished_page').then(({ unpublishedPage: unpublishedPage }) => {
            unpublishedPage.init();
        });
    }

    createApp(Toasts)
        .use(getPiniaInstance())
        .mount('#qg-toast');
}

initToasts();
